import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';
import { IPage, setupPageParams } from 'src/app/shared/utils/page';

@Injectable()
export class VideosService {

  private endpointURL_videos = 'video/all';
  private endpointURL_videos_paged = 'video/pages';
  private endpointURL_channels = 'channel/all';
  private endpointURL_videos_by_channel = 'video/channel/';

  constructor(private http: HttpClient) { }

  // get all videos
  getVideosData(): Observable<any> {
    return this.http.get(this.endpointURL_videos,{withCredentials : true});
  }
  // get all videos
  getVideosDataPaged(page, size): Observable<any> {
    return this.http.get(this.endpointURL_videos_paged + '?page='+page+'&size='+size,{withCredentials : true});
  }
  // get all channels
  getChannelsData(): Observable<any> {
    return this.http.get(this.endpointURL_channels,{withCredentials : true});
  }
  // get user subscribed channels
  getSubscribedChannels(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/subscribedChannels`,{withCredentials : true});
  }
  // get user subscribed channels with video (paginated)
  getSubscribedChannelsWithVideos(userId: string, page: number = 0, size: number = 10): Observable<IPage<any>> {
    const params = { params: { ...setupPageParams(page, size) }, withCredentials: true };
    return this.http.get<IPage<any>>(`user-info/qID/${userId}/subscriptions/channels/videos`, params);
  }
  // get videos with channel id
  getVideosFromChannel(channelNumber): Observable<any> {
    return this.http.get(this.endpointURL_videos_by_channel + channelNumber,{withCredentials : true});
  }
  // get videos with channel id
  getVideosFromChannelPaged(channelNumber, page, size): Observable<any> {
    return this.http.get(this.endpointURL_videos_by_channel + channelNumber + '?page='+page+'&size='+size,{withCredentials : true});
  }
  // get user liked videos
  getUserVideoLikesList(userId) {
    return this.http.get(`user-info/qID/${userId}/videoLikedlist`,{withCredentials : true});
  }
  // get user disliked videos
  getUserVideoDisLikesList(userId) {
    return this.http.get(`user-info/qID/${userId}/videoDislikedlist`,{withCredentials : true});
  }
  // get video like/dislike status
  getUserVideoLikesDislikes(userId, videoId) {
    return this.http.get(`user-info/qID/${userId}/findVideoLikedOrDisliked/${videoId}`,{withCredentials : true});
  }
  // subscribe/unsubscribe to channel
  toggleSubscribeChannel(userId, channelId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/subscribeChannel/${channelId}`, '',{withCredentials : true});
  }
  // increment user likes
  postVideoLikes(userId, videoId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addVideoToLikelist/${videoId}`, '',{withCredentials : true});
  }
  // increment user dislikes
  postVideoDislikes(userId, videoId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addVideoToDislikelist/${videoId}`, '',{withCredentials : true});
  }
  // increment views of video by user
  postVideoViews(userId, videoId) {
    const sanitizedUserId = ValidationUtils.sanitizeQID(userId);
    const sanitizedVideoId = ValidationUtils.sanitizeRemoveSymbols(videoId);
    return this.http.post(`user-info/qID/${sanitizedUserId}/addVideoToViewlist/${sanitizedVideoId}`, '',{withCredentials : true});
  }
  // add/remove video from watchlist by user
  toggleVideoWatchlist(userId, videoId) {
    return this.http.post(`user-info/qID/${userId}/manageVideoWatchlist/${videoId}`, '',{withCredentials : true});
  }
  // add video from watchlist by user
  addVideoToWatchlist(userId, videoId) {
    return this.http.post(`user-info/qID/${userId}/addVideoToWatchlist/${videoId}`, '');
  }
  // get list user watchlisted videos
  getUsersWatchlist(userId) {
    return this.http.get(`user-info/qID/${userId}/videoWatchlist`, { withCredentials: true });
  }
  // get user history of videos
  getUserWatchHistory(userId) {
    return this.http.get(`user-info/qID/${userId}/videoHistorylist`, { withCredentials: true });
  }
  // remove video from user's watchlist
  removeVideoFromWatchlist(userId, videoId) {
    return this.http.post(`user-info/qID/${userId}/removeVideoFromWatchlist/${videoId}`, '', { withCredentials: true });
  }
  // save user's watchlist sort order
  saveWatchlistSortOrder(userId, videoList) {
    return this.http.post(`user-info/qID/${userId}/updateAllSortedVideoWatchlist`, videoList, { withCredentials: true });
  }

  getVideoLinkParam(videoNumber, makeName): Observable<any> {
    return this.http.get(`video/getVideoLink/${videoNumber}?makeName=${makeName}`);
  }
}
